import { takeLatest, call, put } from 'redux-saga/effects';
import axios from 'axios';
import { verifyPhoneSuccess, verifyPhoneFailure } from '../slice/otpSlice';
const url = process.env.REACT_APP_API_URL;
function* verifyPhoneRequest(action) {
  try {
 const response=   yield call(() => axios.post(`${url}/otpVerify`, action.payload));
 if(response.data.status=="success"){
  yield put(verifyPhoneSuccess());
    
 }else{
  yield put(verifyPhoneFailure(response.data.message));
 }
  } catch (error) {
    yield put(verifyPhoneFailure(error.message));
  }
}



export function* watchVerifyPhone() {
  yield takeLatest('otp/verifyPhone', verifyPhoneRequest);
}
